import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CouncilStatsService {
  councilGradingStatsCollectionName = `councilGradingStats-${environment.fraternalYear}`;

  constructor(private firestore: AngularFirestore) { }

  getAllCouncilGradingStats() {
    return this.firestore.collection(this.councilGradingStatsCollectionName).snapshotChanges();
  }

  getCouncilGradingStats(councilId: string) {
    return this.firestore.collection(this.councilGradingStatsCollectionName).doc(councilId).snapshotChanges();
  }
}

export interface CouncilStats {
  councilId: string;
  diocese: string;
  division: string;
  faithTotal: number;
  familyTotal: number;
  communityTotal: number;
  lifeTotal: number;
  membershipTotal: number;
  councilTotal: number;
}
